import React from "react"
import { Box, Flex, useMediaQuery, Text, Button, Heading } from "@chakra-ui/react"
import { mobileBreakpoint } from "../../common/commonConstants"
import { useNavigate } from "react-router"
import { getLandscapeOrPortraitValues } from "../../components/commons/utils"
import { ModalThreeRowLayout } from "../../components/commons/modalThreeRowLayout"

export const VerificationSuccess = (): JSX.Element => {
  const defaultUserName = "User"
  const firstName = localStorage.getItem("user-fname")
  const lastName = localStorage.getItem("user-lname")
  const username = firstName !== null && lastName !== null ? firstName + " " + lastName : defaultUserName
  const [isDesktop] = useMediaQuery(`(min-width: ${mobileBreakpoint}px)`)
  const [isLandscape] = useMediaQuery("(orientation: landscape)")
  const [isLargerThan800] = useMediaQuery("(min-width: 815px)")
  const navigate = useNavigate()

  return (
    <ModalThreeRowLayout
      firePos="left"
      middleComponent={
        <Box color="white" textAlign={"left"} p="4" pt="0">
          <Heading color="white" variant={"Heading1"} textAlign={"center"} mt="0" mb="4">
            {isLandscape && <>Welcome to Snap Fire Systems</>}
            {!isLandscape && (
              <>
                Welcome to <br />
                Snap Fire Systems
              </>
            )}
          </Heading>
          <Text
            variant={"RHeading4Bold"}
            mb={[
              getLandscapeOrPortraitValues("2", "4", isLandscape),
              getLandscapeOrPortraitValues("2", "4", isLandscape),
              getLandscapeOrPortraitValues("2", "4", isLandscape),
              8,
              8,
              8
            ]}
          >
            Hey <>{username}</>,
          </Text>
          <Box
            my={[
              getLandscapeOrPortraitValues("0", "6", isLandscape),
              getLandscapeOrPortraitValues("0", "6", isLandscape),
              getLandscapeOrPortraitValues("2", "6", isLandscape),
              getLandscapeOrPortraitValues("2", "6", isLandscape),
              getLandscapeOrPortraitValues("2", "6", isLandscape),
              6
            ]}
          >
            {isLandscape && !isLargerThan800 && (
              <Text
                variant="RBody"
                mb={[
                  getLandscapeOrPortraitValues("0", "2", isLandscape),
                  getLandscapeOrPortraitValues("0", "2", isLandscape),
                  getLandscapeOrPortraitValues("0", "2", isLandscape),
                  2,
                  2,
                  2
                ]}
              >
                Your account with us is now verified.&nbsp; Now that you’re a member, you can:
              </Text>
            )}
            {(!isLandscape || (isLandscape && isLargerThan800)) && (
              <>
                <Text
                  variant="RBody"
                  mb={[
                    getLandscapeOrPortraitValues("0", "2", isLandscape),
                    getLandscapeOrPortraitValues("0", "2", isLandscape),
                    getLandscapeOrPortraitValues("0", "2", isLandscape),
                    2,
                    2,
                    2
                  ]}
                >
                  Your account with us is now verified.&nbsp;
                </Text>
                <Text
                  variant="RBody"
                  mb={[
                    getLandscapeOrPortraitValues("0", "2", isLandscape),
                    getLandscapeOrPortraitValues("0", "2", isLandscape),
                    getLandscapeOrPortraitValues("0", "2", isLandscape),
                    2,
                    2,
                    2
                  ]}
                >
                  Now that you’re a member, you can:
                </Text>
              </>
            )}
            <ul
              style={{
                marginTop: getLandscapeOrPortraitValues("0px", "8px", isLandscape),
                marginLeft: "-16px",
                paddingLeft: "40px",
                marginBottom: isDesktop ? "24px" : getLandscapeOrPortraitValues("2px", "12px", isLandscape)
              }}
            >
              <li>create personalised Fire Management Plans (FMPs)</li>
              <li>use the selection filter to identify and save your interested products</li>
              <li>easily print out an FMP to send to project managers</li>
            </ul>
            <Text
              variant="RBody"
              mb={[
                getLandscapeOrPortraitValues("0", "6", isLandscape),
                getLandscapeOrPortraitValues("0", "2", isLandscape),
                getLandscapeOrPortraitValues("0", "6", isLandscape),
                getLandscapeOrPortraitValues("6", "6", isLandscape),
                getLandscapeOrPortraitValues("6", "6", isLandscape),
                6
              ]}
            >
              Try it out now!
            </Text>
          </Box>
          <Flex justify={["center", "center", "flex-start"]}>
            <Button
              variant="Button1RegularOutline"
              onClick={() => {
                // deliberately navigating to login page instead of homepage. Because, the user Id is not created at this point of time.
                // It will be available only after logging in for the first time.
                navigate("/login")
              }}
            >
              Get Started
            </Button>
          </Flex>
        </Box>
      }
      footerComponent={<></>}
    />
  )
}
